<template>
  <div class="sidebar-container">
    <el-menu mode="vertical" unique-opened :default-active="$route.path" background-color="#304156" text-color="#fff" active-text-color="#409EFF">
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </div>
</template>

<script>
import sidebarItem from './sidebarItem'

export default {
  components: { sidebarItem },
  computed: {
    routes() {
      // console.log('console.log(global.antRouter):')
      // console.log(global.antRouter)
      return global.antRouter
    }
   
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/sidebar.vue